import './EditFileButton.scss';
import { Button } from '@trackman/web-shared-components';
import { ReactComponent as Pencil } from 'images/icons/Pencil.svg';
import { ReactComponent as Plus } from 'images/icons/Plus.svg';

type Props = {
  isAdd: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const EditFileButton = ({ isAdd, disabled, onClick }: Props) => {
  return (
    <Button
      className={isAdd ? 'edit-file-button edit-file-button__add' : 'edit-file-button edit-file-button__edit'}
      variant='contained'
      intent={isAdd ? 'secondary' : 'default'}
      startIcon={isAdd ? <Plus className='icon__add' /> : <Pencil className='icon__edit' />}
      disabled={disabled ?? false}
      onClick={onClick}
    >
      {isAdd ? 'Add file' : 'Edit file'}
    </Button>
  );
};
